import {
  pricingDispatches,
  termsConditionsDispatches,
  userSliderConstants
} from 'pages/pricing/containers/pricingContainer/constants';
import { pricingService } from 'services';
import { getPanelBackendUrl, messageNotification, validateLoginSession } from 'helpers';

const fetchPaymentMethod = () => {
  return (dispatch) => {
    pricingService
      .fetchPaymentMethod()
      .then((paymentMethod) => {
        dispatch(pricingDispatches.fetchPaymentMethodSuccess(paymentMethod));
      })
      .catch((error) => {
        dispatch(pricingDispatches.fetchPaymentMethodFailure(error));
        validateLoginSession(dispatch, error);
        if (error) {
          messageNotification('danger', 'There was an error fetching payment method', error);
        }
      });
  };
};

const updateOrgTermsConditions = (accept_terms_conditions, inputs) => {
  return (dispatch) => {
    if (getPanelBackendUrl()) {
      return pricingService.updateOrgTermsConditions(accept_terms_conditions, inputs).catch((error) => {
        if (error.response) {
          messageNotification('danger', 'There was an error accepting terms and conditions', error.response);
        }
      });
    } else {
      dispatch(termsConditionsDispatches.updateTermsConditionsFailure());
    }
  };
};

export const createBillingSession = () => {
  pricingService
    .billingPortalSession()
    .then((data) => {
      window.location.href = data.data.url;
    })
    .catch((error) => {
      messageNotification('danger', error.error || 'something went wrong creating session.');
    });
};

export const setUserSliderCount = (value) => ({
  type: userSliderConstants.SET_COUNT,
  payload: value
});

export const pricingActions = {
  fetchPaymentMethod,
  updateOrgTermsConditions
};
